import { ITVServiceToya } from '@/shared/services/types/tvService/tvServiceInterfaces'
import { IVODServiceToya } from '@/shared/services/types/vodService/vodServiceInterfaces'
import { IEPGServiceToya } from '@/shared/services/types/epgService/epgServiceInterfaces'
import TVServiceToya from '@/shared/services/containers/TVService/TVServiceToya'
import EPGServiceToya from '@/shared/services/containers/EPGService/EPGServiceToya'
import VODServiceToya from '@/shared/services/containers/VODServices/VODServiceToya'
import VODServiceCODESPOT from '@/shared/services/containers/VODServices/VODServiceCODESPOT'
import LoginAndProfileService from '@/shared/services/containers/LoginAndProfileService/LoginAndProfileService'
import { ILoginAndProfileService } from '@/shared/services/types/loginAndProfile/loginAndProfileTypes'

export type Service =
    | ITVServiceToya
    | IVODServiceToya
    | IEPGServiceToya
    | ILoginAndProfileService

interface Registry {
    [key: string]: Service
}

export const DIContainer = {
    registry: {
        TVServiceTOYA: TVServiceToya,
        EPGServiceTOYA: EPGServiceToya,
        VODServiceTOYA: VODServiceToya,
        VODServiceCODESPOT,
        LoginAndProfileCodespot: LoginAndProfileService,
    } as Registry,
    resolve(identifier: string): Service {
        if (!this.registry.hasOwnProperty(identifier)) {
            throw new Error(
                `Object with identifier ${identifier} not found in container`
            )
        }
        return this.registry[identifier]
    },
}
